import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {donateMobileState} from "../../../../inline-donation/DonateMobileState";
import {LoadingSpinner} from "../../../../../ui/LoadingSpinner";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {INLINE_DONATION_URLS, INLINE_EDIT_DONATION_URLS} from "../../../../PanelConstants";
import {UsingCardComponent} from "../../payment-method/components/UsingCardComponent";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {PaymentMethodStore} from "../../../../../../client/state/PaymentMethodStore";
import {DonationStore} from "../../../../../../client/state/DonationStore";
import {BasePanelPage, BasePanelPageStyle} from "../../BasePanelPage";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";
import {DonateComponent, DonateComponentStyle} from "../components/DonateComponent";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {autoredraw} from "../../../../../../stem-core/src/decorators/AutoRedraw";
import {paymentMethodController} from "../../../../inline-donation/PaymentMethodController";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";


class EditDonationComponent extends DonateComponent {
    updateDonation() {
        donateMobileState.updateDonation(donateMobileState.getTotalAmount());
    }
}

class EditDonationPanelComponentStyle extends DonateComponentStyle {
    @styleRuleInherit
    title = {
        display: "none",
    };
}

@registerStyle(EditDonationPanelComponentStyle)
class EditDonationPanelComponent extends EditDonationComponent {}

class EditDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    description = {
        display: "inline",
    };

    @styleRule
    inlineLink = {
        ...this.themeProps.PANEL_LINK,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        display: "inline-block",
    };

    @styleRuleInherit
    body = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    }
}

@autoredraw(PaymentMethodStore, DonationStore)
@registerStyle(EditDonationPanelStyle)
export class EditDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editDonationInlineTitle,
        };
    }

    isButtonDisabled() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        return !(donateMobileState.isValid()
            && (donateMobileState.donationAmount !== donation.computeAmount()
                || donateMobileState.payDonationFeeCheckboxChecked !== donation.isDonationFeePaid()
                || donation.getPaymentMethod() !== paymentMethodController.selectedPaymentMethod));
    }

    updateDonation() {
        LoadingSpinner.show();
        this.editDonationComponent.updateDonation();
    }

    render() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        paymentMethodController.initialPaymentMethod = paymentMethodController.selectedPaymentMethod;

        return [
            <div>
                <MessageElement className={styleSheet.description}
                                message={Messages.donatePageRecurringDonationMessage(donation.formatPrice())}/>
                <Link value={Messages.here} className={styleSheet.inlineLink} href={INLINE_EDIT_DONATION_URLS.cancel}/>.
            </div>,
            iFrameMerchantService.isCDSPaymentMethod() ? null :
                <UsingCardComponent card={paymentMethodController.selectedPaymentMethod} hideTitle={true}
                                    onChangeCard={() => Router.changeURL(INLINE_EDIT_DONATION_URLS.card)}
                                    changeCardMessage={Messages.edit} />,
            <EditDonationPanelComponent ref="editDonationComponent" changeURL={this.options.changeURL}
                                        onChange={() => this.redraw()}/>,
            <MerchantButton label={donateMobileState.getEditDonationComponentButtonLabel()}
                            disabled={this.isButtonDisabled()} onClick={() => this.updateDonation()}
                            className={styleSheet.button} ref="button"/>,
        ];
    }

    onMount() {
        super.onMount();

        this.redraw(); // We need this first redraw because we have interdependent components
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument()) {
                if (!iFrameUserDataService.getActiveRecurringDonation()) {
                    Router.changeURL(INLINE_DONATION_URLS.donate);
                } else {
                    this.redraw();
                }
            }
        });
    }
}
